import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageKey, StorageService } from '../../services/common/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrl: './change-email.component.scss',
})
export class ChangeEmailComponent {
  ChangeEmailForm: FormGroup;
  userData: any;
  constructor(
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.ChangeEmailForm = this.formBuilder.group({
      currentEmail: [{ value: '', disabled: true }],
      newEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonService.emailRegex),
        ],
      ],
      confirmEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonService.emailRegex),
        ],
      ],
    });
  }

  ngOnInit(): void {
    this.userData = this.storageService.getTokenData();
    this.ChangeEmailForm.patchValue({
      currentEmail: this.userData.Email
    })
  }

  OnchangeEmail() {
    Object.keys(this.ChangeEmailForm.controls).forEach((key) => {
      const control = this.ChangeEmailForm.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });

    if (this.ChangeEmailForm.valid) {
      const FormData = {
        Email: this.ChangeEmailForm.value.newEmail,
        UserTypeId: this.userData.UserTypeId,
        CurrentEmail: this.userData.Email
      };

      if (
        this.ChangeEmailForm.value.newEmail !=
        this.ChangeEmailForm.value.confirmEmail
      ) {
        this.toaster.error(this.translate.instant('EMAIL_NOT_MATCH_TOASTER'));
        return;
      }
      this.spinner.show();
      const apiUrl = this.apiUrl.apiUrl.account.sentOTPToUser;
      this.apiService.doPost(apiUrl, FormData).pipe().subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response && response.Success) {
            this.toaster.success(this.translate.instant(response.Message));
            let email = this.commonService.Encrypt(FormData.Email);
            let userType = this.commonService.Encrypt(this.userData.UserTypeId.toString());
            this.router.navigate(['/change-email-otp-verification'], {
              queryParams: { email: email, userType: userType },
            })
          }
          else {
            this.toaster.error(this.translate.instant(response.Message));
          }
        },
        error: (er) => {
          this.spinner.hide();
          console.error(er);
          this.toaster.error(er.Message);
        }
      });
    }
  }

  goBack() {
    window.history.back();
  }
}
